import { Bank, parseBank } from "../../bank";
import { Employee, parseEmployee } from "../../employee";
import { LenderPortfolio, parseLenderPortfolio } from "../../lender-portfolio";
import { parseProposal, Proposal } from "../../proposal";
import { parseUser, User } from "../../user";
import { parseDate } from "../date";

export function getKeyByItemIncludes<T>(object: any, item: any): T {
  const keys: T[] = Object.keys(object).map((key) => (key as unknown) as T);
  return keys.find((key) => object[key].includes(item));
}

export function bindData<Type>(object: Type, data: Type) {
  Object.keys(object).forEach((key) => {
    object[key] = data[key];
  });
}

export function bindDjangoData<Type, Interface>(object: Type, data: Interface) {
  Object.keys(object).forEach((key) => {
    const keySnakeCase = key.split(/(?=[A-Z])/).join('_').toLowerCase();
    if (Array.isArray(object[key])) {
      data[keySnakeCase].forEach((item) => {
        if (typeof item === 'object') {
          const clone = new object[key][0].constructor();
          bindDjangoData(clone, item);
          object[key].push(clone);
        } else {
          object[key].push(item);
        }
      });
      object[key].shift();
    } else if (object[key] instanceof Date) {
      object[key] = parseDate(data[keySnakeCase]);
    } else if (object[key] instanceof Bank) {
      object[key] = parseBank(data[keySnakeCase]);
    } else if (object[key] instanceof Employee) {
      object[key] = parseEmployee(data[keySnakeCase]);
    } else if (object[key] instanceof LenderPortfolio) {
      object[key] = parseLenderPortfolio(data[keySnakeCase]);
    } else if (object[key] instanceof Proposal) {
      object[key] = parseProposal(data[keySnakeCase]);
    } else if (object[key] instanceof User) {
      object[key] = parseUser(data[keySnakeCase]);
    } else {
      object[key] = data[keySnakeCase];
    }
  });
}
